import React from "react";

import { ReactComponent as CheckboxChecked } from "../../assets/icons/checkbox_checked.svg";
import { ReactComponent as CheckboxUnChecked } from "../../assets/icons/checkbox_unchecked.svg";

import styles from "./CheckBox.module.scss";
import classNames from "classnames";

const CheckBox = ({ checked, onClick, className }) => {
  return (
    <div
      className={classNames(styles.checkBoxContainer, className)}
      onClick={onClick}
    >
      {checked ? <CheckboxChecked /> : <CheckboxUnChecked />}
    </div>
  );
};

CheckBox.defaultProps = {
  checked: false,
  onClick: () => alert("onClick"),
};

export default CheckBox;
